module.exports = __webpack_public_path__ + "src/img/close.e3a0e9b5.svg";